import { FC } from "react";
import {
  Typography,
  Container,
  Box,
  Grid,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { CommunityStyle } from "../Styles/LandingStyles";
import trusted from "../../assets/images/trusted.svg";
import competent from "../../assets/images/competent.svg";
import compliant from "../../assets/images/compliant.svg";

const levels = [
  {
    title: "Early",
    description:
      "Get in on highly vetted projects before the crowd",
    image: trusted,
  },
  {
    title: "Refundable",
    description:
      "100% refund guarantee of your investment",
    image: competent,
  },
  {
    title: "Compliant",
    description:
      "We are regulated to ensure the best service for our clients",
    image: compliant,
  },
];

const Community: FC = () => {
  const classes = CommunityStyle();
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <>
      <Box
        data-aos="fade-up"
        data-aos-duration="1200"
        className={classes.community}
        component="section"
      >
        <Container fixed>
          <Grid container>
            <Grid item md={12}>
              {" "}
              <Box textAlign={"center"}>
                <Typography variant="h2" color="primary">
                  {" "}
                  <Typography
                    component="span"
                    className="aspekta-medium hero-blue"
                    style={{ fontSize: isActive ? "28px" : "40px" }}
                    color="secondary"
                  >
                    Take your portfolio to <span className="aspekta-semiBold">The
                    Next level</span>
                  </Typography>
                  <br />
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={!isActive ? 0 : 10}
            alignItems="center"
            justifyContent="center"
          >
           
              {
                levels.map((level, index) => (
                  <Grid  key={index} item md={4} sm={12}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "space-between",
                      height: "231px",
                    }}
                  >
                    <div>
                      <img
                        src={level.image}
                        className="img-fluid"
                        alt="Gains"
                        style={{ height: "80px" }}
                      />
                    </div>
                    <Typography variant="h3" className="aspekta-semiBold">{level.title}</Typography>
                    <Typography variant="body1" className="body1 aspekta-light" style={{color:"#343737", width: "75%" }}>
                      {level.description}
                    </Typography>
                  </div>
                </Grid>
                ))
              }
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Community;
